/*
Purpose: one-off popup shown after login when the TCMS super admin has flagged the
         centre as "Not Paid". Not a block - OK just dismisses it.

Login.js stores the notice the backend returned with the login row in
localStorage.payment_hold_notice ({title, message}); this reads it on the first
authenticated page and removes the key on OK, so it only shows once per login.
Wording lives in tutor-backend/config/payment_hold.js (same text as TCMS).
*/

import React, { useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"

const STORAGE_KEY = "payment_hold_notice"

function readNotice() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

const PaymentHoldNotice = () => {
  const [notice, setNotice] = useState(readNotice)

  const handleOk = () => {
    localStorage.removeItem(STORAGE_KEY)
    setNotice(null)
  }

  if (!notice) return null

  return (
    <Modal isOpen={true} centered backdrop="static" keyboard={false}>
      <ModalHeader className="mt-0">
        <i className="mdi mdi-alert text-warning me-2"></i>
        {notice.title}
      </ModalHeader>
      <ModalBody>
        {String(notice.message || "")
          .split(/\n\s*\n/)
          .map((para, idx, all) => (
            <p key={idx} className={idx === all.length - 1 ? "mb-0" : ""}>
              {para}
            </p>
          ))}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleOk}>
          OK
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default PaymentHoldNotice
